import React, { useEffect, useState, useRef, useContext } from "react";
import { Input } from "design-react-kit";
import { useLocation } from "react-router-dom";
import Repo from "../../Utility/Repo";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { TokenContext } from "../../Components/TokenContext";
import Loader from "../../Components/Loader";
import ListPaymentsOperator from "../../Components/ListPaymentsOperator";
import Select from "../../Components/Select";
import Badge from "../../Components/Badge";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function ListPaymemtsStatus(props) {
  const apiToken = useContext(TokenContext);
  const [paymentsTemp, setPaymentsTemp] = useState();
  const [payments, setPayments] = useState();
  const [loading, setLoading] = useState(true);
  const [viewMode, setViewMode] = useState("user");
  const [pagamentiList, setPagamentiList] = useState([]);
  const [pagamentiListTemp, setPagamentiListTemp] = useState([]);
  const [filter, setFilter] = useState({
    name: "",
    chkNoSendMail: false,
    announcementId: null,
    fiscalcode: "",
    anno: null,
    city: "",
    da: null,
    a: null,
    oraDA: "00:00",
    oraA: "23:59",
    iuv: "",
    title: "",
    status: "",
  });

  const [nomeBando, setNomeBando] = useState("");
  const [statistiche, setStatistiche] = useState("");
  const [announcementOptions, setAnnouncementOptions] = useState([]);
  const [allPayments, setAllPayments] = useState();
  const [allPaymentsBackup, setAllPaymentsBackup] = useState();
  const [allComuni, setAllComuni] = useState([]);
  const options = [
    { value: "", label: "Tutti gli stati" },
    { value: 0, label: "Da pagare" },
    { value: 1, label: "Pagato" },
    { value: 2, label: "Annullato" },
  ];

  useEffect(() => {
    setLoading(false);
    if (apiToken) {
      Repo.getListPaymentFilterOperator(apiToken, {})
        .then((response) => {
          if (response.status == 200) {
            setLoading(true);
            setAllPayments(response.data);
            setAllPaymentsBackup(response.data);
            setPaymentsTemp(response.data);
          }
        })
        .catch((error) => {
          setLoading(true);
          console.log(error);
        });
      Repo.getTotali(apiToken)
        .then((response) => {
          if (response.status == 200) {
            setStatistiche(response.data);
          }
        })
        .catch((error) => {
          setLoading(true);
          console.log(error);
        });
    }
  }, []);

  useEffect(() => {
    const fetchAnnouncements = async () => {
      setLoading(false); // Inizia il caricamento
      try {
        const response = await Repo.getAnnouncementsOperator(apiToken);
        if (response.status === 200) {
          const options = response.data.map((announcement) => ({
            value: announcement.id,
            label: announcement.name,
          }));
          setAnnouncementOptions(options);
        } else {
          throw new Error("Errore nel recupero dei dati"); // Gestisci errori di stato
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(true); // Termina il caricamento
      }
    };
    Repo.getAllComuni(apiToken)
      .then((response) => {
        // Trasforma l'array di stringhe in array di oggetti { value, label }
        const comuniOptions = (response.data || [])
          .filter((c) => !!c)
          .map((c) => ({ value: c, label: c }));
        setAllComuni(comuniOptions);
      })
      .catch((error) => {
        console.log(error);
      });

    fetchAnnouncements();
  }, [apiToken]);

  const handleChange = (selectedOption) => {
    // Aggiorna solo l'announcementId nel filtro
    setFilter((prevFilter) => ({
      ...prevFilter,
      announcementId: selectedOption ? selectedOption.value : null,
    }));

    setNomeBando(selectedOption.label);
  };

  const handleFilterChange = (e) => {
    const { id, value, type, checked } = e.target;
    setFilter((prev) => {
      const newFilter = {
        ...prev,
        [id]: type === "checkbox" ? checked : value,
      };
      localFilter(
        newFilter,
        viewMode === "payment" ? pagamentiList : undefined,
      );
      return newFilter;
    });
  };

  const localFilter = (customFilter, customPagamentiList) => {
    const f = customFilter || filter;
    if (!allPayments && !customPagamentiList) return;
    let filtered = allPayments || [];
    let filteredPagamenti = customPagamentiList || pagamentiList || [];
    if (f.name) {
      filtered = filtered.filter(
        (x) =>
          (x.nome && x.nome.toLowerCase().includes(f.name.toLowerCase())) ||
          (x.cognome && x.cognome.toLowerCase().includes(f.name.toLowerCase())),
      );
      filteredPagamenti = filteredPagamenti.filter(
        (x) =>
          (x.subscription?.user?.firstName &&
            x.subscription.user.firstName
              .toLowerCase()
              .includes(f.name.toLowerCase())) ||
          (x.subscription?.user?.lastName &&
            x.subscription.user.lastName
              .toLowerCase()
              .includes(f.name.toLowerCase())),
      );
    }
    if (f.fiscalcode) {
      filtered = filtered.filter(
        (x) =>
          x.codiceFiscale &&
          x.codiceFiscale.toLowerCase().includes(f.fiscalcode.toLowerCase()),
      );
      filteredPagamenti = filteredPagamenti.filter(
        (x) =>
          x.subscription?.user?.fiscalCode &&
          x.subscription.user.fiscalCode
            .toLowerCase()
            .includes(f.fiscalcode.toLowerCase()),
      );
    }

    if (f.announcementId) {
      filteredPagamenti = filteredPagamenti.filter((x) => {
        const annId =
          x.subscription?.announcementId ?? x.subscription?.announcement?.id;
        return annId == f.announcementId;
      });
    }

    if (f.city) {
      const qCity = f.city.toLowerCase();
      filteredPagamenti = filteredPagamenti.filter(
        (x) =>
          x.subscription?.user?.city &&
          x.subscription.user.city.toLowerCase().includes(qCity),
      );
    }

    if (f.da || f.a) {
      const parseDateTime = (dateStr, timeStr) => {
        if (!dateStr) return null;
        const time = timeStr || "00:00";
        // Create ISO-like string to ensure correct parsing
        return new Date(`${dateStr}T${time}`);
      };

      const start = parseDateTime(f.da, f.oraDA || "00:00");
      const end = parseDateTime(f.a, f.oraA || "23:59");

      filteredPagamenti = filteredPagamenti.filter((x) => {
        if (!x.dataInsert && !x.DataInsert) return false;
        const raw = x.dataInsert ?? x.DataInsert;
        const d = new Date(raw);
        if (start && end) return d >= start && d <= end;
        if (start) return d >= start;
        if (end) return d <= end;
        return true;
      });
    }
    if (f.status || f.status === 0) {
      filteredPagamenti = filteredPagamenti.filter((x) => x.stato == f.status);
    }
    if (f.iuv) {
      const q = f.iuv.toLowerCase();
      filteredPagamenti = filteredPagamenti.filter(
        (x) => x.codIuv && x.codIuv.toLowerCase().includes(q),
      );
    }
    if (f.title) {
      const q = f.title.toLowerCase();
      filteredPagamenti = filteredPagamenti.filter(
        (x) => x.titolo && x.titolo.toLowerCase().includes(q),
      );
    }
    setPaymentsTemp(filtered);
    setPagamentiListTemp(filteredPagamenti);
  };

  const sendFilter = () => {
    setLoading(false);
    if (viewMode === "payment") {
      localFilter(filter, pagamentiList || []);
      setLoading(true);
      return;
    }
    const payload = {
      ...filter,
      DataDa: filter.da || null,
      DataA: filter.a || null,
    };
    Repo.getListPaymentFilterOperator(apiToken, payload)
      .then((response) => {
        setAllPayments(response.data);
        setPaymentsTemp(response.data);
        setLoading(true);
      })
      .catch((error) => {
        console.log(error);
        setLoading(true);
      });
  };

  const ricalcolaPosizioniDebitorie = () => {
    if (
      window.confirm(
        "Sei sicuro di voler procedere con il ricalcolo delle posizioni debitorie?",
      )
    ) {
      Repo.postRiceviPosizioniDebitorie(apiToken)
        .then((response) => {})
        .catch((error) => {
          console.log(error);
        });
    } else {
    }
  };

  const [isUpdating, setIsUpdating] = useState(false);

  return (
    <>
      <h1>Lista pagamenti</h1>
      <div className="row mb-3">
        <div className="col-12">
          <div className="form-check form-check-inline">
            <input
              id="radioUtente"
              className="form-check-input"
              type="radio"
              name="viewMode"
              value="user"
              checked={viewMode === "user"}
              onChange={() => setViewMode("user")}
            />{" "}
            <label className="form-check-label" htmlFor="radioUtente">
              Per utente
            </label>
          </div>
          <div className="form-check form-check-inline">
            <input
              id="radioPagamento"
              className="form-check-input"
              type="radio"
              name="viewMode"
              value="payment"
              checked={viewMode === "payment"}
              onChange={() => {
                setViewMode("payment");
                if (pagamentiList.length === 0) {
                  setLoading(false);
                  Repo.getListPaymentOperator(apiToken, null, null)
                    .then((response) => {
                      setPagamentiList(response.data || []);
                      setPagamentiListTemp(response.data || []);
                      localFilter(null, response.data || []);
                    })
                    .finally(() => {
                      setLoading(true);
                    });
                }
              }}
            />{" "}
            <label className="form-check-label" htmlFor="radioPagamento">
              Per pagamento
            </label>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="clearfix col-lg-8 py-lg-2">
          <p>
            Tutti i pagamenti ancora non effettuati o non ancora registrati sul
            sistema
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col-7">
          <div className="mt-3 shadow-sm p-3 mb-5 bg-white rounded">
            <h4>Filtra Pagamenti</h4>
            <div className="row">
              <div className="col-10 offset-1">
                <div className="form-group mx-3">
                  <Select
                    aria-label="Record"
                    defaultMenuIsOpen={false}
                    required
                    icon={false}
                    name="announcementId"
                    id="announcementsSelect"
                    options={announcementOptions}
                    onChange={(option) => {
                      setFilter((prev) => {
                        const newFilter = {
                          ...prev,
                          announcementId: option ? option.value : null,
                        };
                        localFilter(
                          newFilter,
                          viewMode === "payment" ? pagamentiList : undefined,
                        );
                        return newFilter;
                      });
                      setNomeBando(option ? option.label : "");
                    }}
                    value={
                      announcementOptions.find(
                        (option) => option.value === filter.announcementId,
                      ) || null
                    }
                    placeholder="Seleziona un bando"
                  />
                </div>
              </div>
            </div>
            <div className="row mt-3 d-flex ">
              <div className="col-6">
                <div className="form-group row">
                  <div className="col-7">
                    <label className="active" htmlFor="da">
                      Da
                    </label>
                    <input
                      id="da"
                      type="date"
                      value={filter.da || ""}
                      onChange={(e) =>
                        setFilter((prev) => {
                          const newFilter = {
                            ...prev,
                            [e.target.id]: e.target.value,
                          };
                          localFilter(
                            newFilter,
                            viewMode === "payment" ? pagamentiList : undefined,
                          );
                          return newFilter;
                        })
                      }
                      max={"9999-12-31"}
                    />
                  </div>
                  <div className="col-5 ps-0 pe-4">
                    <input
                      id="oraDA"
                      type="time"
                      value={filter.oraDA || "00:00"}
                      onChange={(e) =>
                        setFilter((prev) => {
                          const newFilter = {
                            ...prev,
                            [e.target.id]: e.target.value,
                          };
                          localFilter(
                            newFilter,
                            viewMode === "payment" ? pagamentiList : undefined,
                          );
                          return newFilter;
                        })
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="form-group row">
                  <div className="col-7">
                    <label className="active" htmlFor="a">
                      A
                    </label>
                    <input
                      id="a"
                      type="date"
                      value={filter.a || ""}
                      onChange={(e) =>
                        setFilter((prev) => {
                          const newFilter = {
                            ...prev,
                            [e.target.id]: e.target.value,
                          };
                          localFilter(
                            newFilter,
                            viewMode === "payment" ? pagamentiList : undefined,
                          );
                          return newFilter;
                        })
                      }
                      max={"9999-12-31"}
                    />
                  </div>
                  <div className="col-5 ps-0 pe-4">
                    <input
                      id="oraA"
                      type="time"
                      value={filter.oraA || "23:59"}
                      onChange={(e) =>
                        setFilter((prev) => {
                          const newFilter = {
                            ...prev,
                            [e.target.id]: e.target.value,
                          };
                          localFilter(
                            newFilter,
                            viewMode === "payment" ? pagamentiList : undefined,
                          );
                          return newFilter;
                        })
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-8 offset-2">
                <div className="form-group mx-3">
                  <Select
                    aria-label="Comune"
                    defaultMenuIsOpen={false}
                    required
                    icon={false}
                    name="comune"
                    id="comuniSelect"
                    options={allComuni}
                    onChange={(option) => {
                      setFilter((prev) => {
                        const newFilter = {
                          ...prev,
                          city: option ? option.value : "",
                        };
                        localFilter(
                          newFilter,
                          viewMode === "payment" ? pagamentiList : undefined,
                        );
                        return newFilter;
                      });
                    }}
                    value={
                      allComuni.find(
                        (option) => option.value === filter.city,
                      ) || null
                    }
                    placeholder="Seleziona un comune"
                  />
                </div>
              </div>
            </div>
            <div className="form-group col-12 text-right">
              <div
                title={
                  !filter.announcementId &&
                  !filter.anno &&
                  !filter.city &&
                  !filter.da &&
                  !filter.a
                    ? "Seleziona almeno un filtro per cercare"
                    : "Cerca"
                }
              >
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={sendFilter}
                  disabled={
                    !filter.announcementId &&
                    !filter.anno &&
                    !filter.city &&
                    !filter.da &&
                    !filter.a
                  }
                >
                  Cerca
                </button>
              </div>
            </div>
            <div className="row">
              <div className="form-group col-6">
                <Input
                  id="name"
                  required
                  label="Ricerca per nome e cognome"
                  type="text"
                  name="name"
                  value={filter.name ? filter.name : ""}
                  onChange={handleFilterChange}
                />
              </div>
              <div className="form-group col-6">
                <Input
                  key="filter.fiscalcode"
                  id="fiscalcode"
                  label="Codice fiscale"
                  type="text"
                  value={filter?.fiscalcode ? filter?.fiscalcode : ""}
                  onChange={(e) => handleFilterChange(e)}
                />
              </div>

              <div className="form-group col-12 text-right">
                <button
                  type="button"
                  className="btn btn-outline-primary m-2"
                  onClick={() => {
                    setFilter({
                      name: null,
                      chkNoSendMail: false,
                      announcementId: null,
                      fiscalcode: "",
                      anno: null,
                      city: "",
                      da: null,
                      a: null,
                      oraDA: "00:00",
                      oraA: "23:59",
                      iuv: "",
                      title: "",
                      status: "",
                    });
                    localFilter(
                      {
                        name: null,
                        chkNoSendMail: false,
                        announcementId: null,
                        fiscalcode: null,
                        anno: null,
                        city: "",
                        da: null,
                        a: null,
                        oraDA: "00:00",
                        oraA: "23:59",
                        iuv: null,
                        title: null,
                        status: null,
                      },
                      viewMode === "payment" ? pagamentiList : undefined,
                    );
                    setAllPayments(allPaymentsBackup);
                    setPaymentsTemp(allPaymentsBackup);
                  }}
                >
                  Reset
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="col-5">
          <div className="callout">
            <div className="callout-inner">
              <div className="callout-title">
                <svg className="icon">
                  <use href={`${iconSprite}#it-info-circle`} />
                </svg>

                <span className="text">Statistiche Pagamenti</span>
              </div>
              <p>
                <ul className="space-y-1">
                  {Object.entries(statistiche).map(([nome, valore]) => (
                    <li
                      key={nome}
                      className="flex justify-between border-b pb-1"
                    >
                      <span>{nome}: </span>
                      <strong>{valore ? valore?.toFixed(2) : "0.00"} €</strong>
                    </li>
                  ))}
                </ul>
              </p>
              <div className="d-grid text-right">
                <button
                  type="button"
                  className="btn btn-success m-2"
                  onClick={ricalcolaPosizioniDebitorie}
                  disabled={isUpdating} // Disabilita il pulsante mentre l'importazione è in corso
                >
                  {isUpdating ? (
                    <>Importazione in corso...</>
                  ) : (
                    <>Sincronizza</>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {viewMode === "user" ? (
        <>
          {paymentsTemp && paymentsTemp.length > 0 ? (
            <ListPaymentsOperator
              payments={payments}
              paymentsTemp={paymentsTemp}
              setPayments={setPayments}
              fiscalCode={true}
              goBack={true}
              nomeBando={nomeBando}
            />
          ) : (
            <>
              <div className="alert alert-warning" role="alert">
                <strong>Attenzione! </strong> Non ci sono pagamenti!
              </div>
            </>
          )}
        </>
      ) : (
        <>
          {pagamentiList && pagamentiList.length > 0 ? (
            <div className="card-wrapper card-space">
              <div className="card card-bg card-big roundedCustom no-after">
                <div className="card-body">
                  <div className="row">
                    <div className="col-lg-3 text-center">
                      <strong>Utente</strong>
                    </div>
                    <div className="col-lg-2 text-center px-2">
                      <Input
                        id="iuv"
                        label="IUV"
                        type="text"
                        name="iuv"
                        onChange={handleFilterChange}
                        value={filter.iuv}
                      />
                    </div>
                    <div className="col-lg-3 text-center  px-2">
                      <Input
                        id="title"
                        label="Titolo"
                        type="text"
                        name="title"
                        onChange={handleFilterChange}
                        value={filter.title}
                      />
                    </div>
                    <div className="col-lg-1 text-center">
                      <strong>Importo</strong>
                    </div>
                    <div className="col-lg-2 text-center">
                      <Select
                        aria-label="Stato"
                        name="status"
                        id="statusSelect"
                        options={options}
                        onChange={(option) => {
                          setFilter((prev) => {
                            const newFilter = {
                              ...prev,
                              status: option ? option.value : "",
                            };
                            localFilter(
                              newFilter,
                              viewMode === "payment"
                                ? pagamentiList
                                : undefined,
                            );
                            return newFilter;
                          });
                        }}
                        value={options.find((o) => o.value === filter.status)}
                      />
                    </div>
                    <div className="col-lg-1 text-center">
                      <strong>Data Creazione</strong>
                    </div>
                  </div>
                  {pagamentiListTemp.map((x, index) => (
                    <div className="row mt-2" key={index}>
                      <div className="col-lg-3 text-left">
                        {x.subscription?.user?.fiscalCode} <br />
                        {x.subscription?.user?.firstName}{" "}
                        {x.subscription?.user?.lastName}
                      </div>
                      <div
                        className="col-lg-2 text-center"
                        style={{ fontFamily: "monospace" }}
                      >
                        {x.codIuv}
                      </div>
                      <div className="col-lg-3 text-center">{x.titolo}</div>
                      <div className="col-lg-1 text-right">
                        {x.importoDovuto
                          ? `${parseFloat(x.importoDovuto).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`
                          : "0,00 €"}
                      </div>
                      <div className="col-lg-2 text-center">
                        <Badge
                          badgeStatus={
                            (x.stato != 0 && x.importoTotalePagato === 0) ||
                            x.stato == 2
                              ? "bg-danger"
                              : x.stato != 0
                                ? "bg-success"
                                : "bg-primary"
                          }
                          badgeText={
                            (x.stato != 0 && x.importoTotalePagato === 0) ||
                            x.stato == 2
                              ? "Annullato"
                              : x.stato != 0
                                ? "Pagato"
                                : "Da pagare"
                          }
                          title={x?.dataEsitoSingoloPagamento}
                        />
                      </div>
                      <div className="col-lg-1 text-center p-0">
                        {x.dataInsert
                          ? new Date(x.dataInsert).toLocaleDateString("it-IT")
                          : "-"}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ) : (
            <>
              <div className="alert alert-warning" role="alert">
                <strong>Attenzione! </strong> Non ci sono pagamenti!
              </div>
            </>
          )}
        </>
      )}

      {!loading && <Loader></Loader>}
    </>
  );
}

export default ListPaymemtsStatus;
